export enum ProbeDataGraphType {
  last24HoursAverage = 1,
  last7DaysAverage = 2,
  last24HoursMax = 3,
  last7DaysMax = 4,
  last24HoursMin = 5,
  last7DaysMin = 6,
}
